export interface IRoute {
    route: string;
    activeTabId: number;
}
